import { ActionBar } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../translations';

type NfzPasswordChangeActionProps = { onClick: VoidFunction };

export const NfzPasswordChangeAction = (props: NfzPasswordChangeActionProps): JSX.Element => {
   return (
      <ActionBar.PrimaryLink
         testId={'passwordChangeEnabled'}
         label={nfzLoginTranslationKeys.changeNFZPassword}
         onClick={props.onClick}
      />
   );
};
